/**
 * @generated SignedSource<<ced688964ad3a7af1166ee8c35c27400>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type timeRegisteredPerPersonPortfolio_Query$variables = {
  shareKey?: string | null;
  weekPickerSelectedDate?: string | null;
  componentId?: string | null;
  personIds?: ReadonlyArray<string | null> | null;
  teamIds?: ReadonlyArray<string | null> | null;
  roleIds?: ReadonlyArray<string | null> | null;
  labelIds?: ReadonlyArray<string | null> | null;
};
export type timeRegisteredPerPersonPortfolio_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"timeRegisteredPerPersonPortfolio_viewer">;
  } | null;
};
export type timeRegisteredPerPersonPortfolio_Query = {
  variables: timeRegisteredPerPersonPortfolio_Query$variables;
  response: timeRegisteredPerPersonPortfolio_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "labelIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekPickerSelectedDate"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "insight_time_per_person_portfolio"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"insight_time_per_person_portfolio\")"
},
v9 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v10 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v11 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v12 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v13 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v14 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v15 = {
  "kind": "Variable",
  "name": "weekPickerSelectedDate",
  "variableName": "weekPickerSelectedDate"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mondayRegistered",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mondayWorkingHours",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesdayRegistered",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesdayWorkingHours",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesdayRegistered",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesdayWorkingHours",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursdayRegistered",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursdayWorkingHours",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fridayRegistered",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fridayWorkingHours",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturdayRegistered",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturdayWorkingHours",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sundayRegistered",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sundayWorkingHours",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRegistered",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalWorkingHours",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "timeRegisteredPerPersonPortfolio_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "timeRegisteredPerPersonPortfolio_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "timeRegisteredPerPersonPortfolio_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": [
              (v13/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "concreteType": "TimeRegisteredPerPersonPortfolio",
                "kind": "LinkedField",
                "name": "timeRegisteredPerPersonPortfolio",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startWeekOnMonday",
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegisteredPerPersonPortfolioListElement",
                    "kind": "LinkedField",
                    "name": "listData",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "role",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureDefaultId",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegisteredPerPersonPortfolioListElement",
                        "kind": "LinkedField",
                        "name": "nestedListData",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          (v33/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v21/*: any*/),
                          (v23/*: any*/),
                          (v25/*: any*/),
                          (v27/*: any*/),
                          (v29/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6f5904a35ec5ba7b3e84194dc4515d75",
    "id": null,
    "metadata": {},
    "name": "timeRegisteredPerPersonPortfolio_Query",
    "operationKind": "query",
    "text": "query timeRegisteredPerPersonPortfolio_Query(\n  $shareKey: String\n  $weekPickerSelectedDate: String\n  $componentId: ID\n  $personIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n) {\n  viewer {\n    actualPersonId\n    component(name: \"insight_time_per_person_portfolio\")\n    ...timeRegisteredPerPersonPortfolio_viewer_2fpBGs\n    id\n  }\n}\n\nfragment timeRegisteredPerPersonPortfolio_viewer_2fpBGs on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    timeRegisteredPerPersonPortfolio(weekPickerSelectedDate: $weekPickerSelectedDate, componentId: $componentId, personIds: $personIds, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds) {\n      id\n      startWeekOnMonday\n      mondayRegistered\n      mondayWorkingHours\n      tuesdayRegistered\n      tuesdayWorkingHours\n      wednesdayRegistered\n      wednesdayWorkingHours\n      thursdayRegistered\n      thursdayWorkingHours\n      fridayRegistered\n      fridayWorkingHours\n      saturdayRegistered\n      saturdayWorkingHours\n      sundayRegistered\n      sundayWorkingHours\n      totalRegistered\n      totalWorkingHours\n      listData {\n        id\n        name\n        role\n        profilePictureId\n        profilePictureDefaultId\n        mondayRegistered\n        mondayWorkingHours\n        tuesdayRegistered\n        tuesdayWorkingHours\n        wednesdayRegistered\n        wednesdayWorkingHours\n        thursdayRegistered\n        thursdayWorkingHours\n        fridayRegistered\n        fridayWorkingHours\n        saturdayRegistered\n        saturdayWorkingHours\n        sundayRegistered\n        sundayWorkingHours\n        totalRegistered\n        totalWorkingHours\n        nestedListData {\n          id\n          name\n          mondayRegistered\n          tuesdayRegistered\n          wednesdayRegistered\n          thursdayRegistered\n          fridayRegistered\n          saturdayRegistered\n          sundayRegistered\n          totalRegistered\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f16a318756f70dafa787f77278711529";

export default node;
